import React, { useEffect, useState } from 'react'
import PageLoader from '../../shared/PageLoader'
import { useAppDispatch, useAppSelector } from '../../../redux/hook';
import { getAllCompaniesDetails, getAssociateCompanies, getLocations, getStates } from '../../../redux/features/inputModule.slice';
import { 
  Box, Button, Drawer, FormControl, FormControlLabel, FormLabel, IconButton, 
  InputAdornment, InputLabel, MenuItem, Modal, OutlinedInput, Radio, RadioGroup, 
  Select, Table, TableBody, TableCell, TableContainer, TableHead, 
  TablePagination, TableRow, TableSortLabel, TextField, Typography 
} from '@mui/material';

import { DEFAULT_OPTIONS_PAYLOAD, DEFAULT_PAYLOAD } from '../../common/Table';

import { 
  addHoliday, deleteHoliday, editHoliday, getHolidaysList, 
  resetAddHolidayDetails, resetDeleteHolidayDetails, resetEditHolidayDetails, 
  resetGetHolidayDetailsStatus, resetUploadHolidayDetails, uploadHoliday 
} from '../../../redux/features/holidayList.slice';

import { ERROR_MESSAGES } from '../../../utils/constants';

import { toast } from 'react-toastify';

import { 
  getEmployeeBackendCount, getEmployeeDashboardCounts, getEmployeeInputDashboard, 
  getErrorLogs, resetEmployeeBackendCountDetailsStatus, resetEmployeeDashboardCountsDetailsStatus, 
  resetEmployeeInputDashboardDetailsStatus, resetErrorLogsDetailsStatus 
} from '../../../redux/features/dashboard.slice';

import { 
  FaCheck, FaCloudDownloadAlt, FaCloudUploadAlt, 
  FaCode, FaRegEye, FaRegKeyboard 
} from 'react-icons/fa';
import { FaRegCircleCheck } from 'react-icons/fa6'
import { MdOutput } from "react-icons/md";
import { IoMdClose } from 'react-icons/io';
import { getBasePath } from '../../../App';
import { navigate } from 'raviger';
import axios from 'axios';
import { hasUserAccess } from '../../../backend/auth';
import { USER_PRIVILEGES } from '../UserManagement/Roles/RoleConfiguration';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';


const InputsDashboard = () => {

  const dispatch = useAppDispatch();

  const employeeDashboardCountsDetails = useAppSelector((state) => state.inputDashboard.employeeDashboardCountsDetails)
  const employeeInputDashboardDetails = useAppSelector((state) => state.inputDashboard.employeeInputDashboardDetails)
  const employeeBackendCountDetails = useAppSelector((state) => state.inputDashboard.employeeBackendCountDetails)
  const getErrorLogDetails = useAppSelector((state) => state.inputDashboard.errorLogsDetails);

  const employeeCounts = employeeDashboardCountsDetails && employeeDashboardCountsDetails.data && employeeDashboardCountsDetails.data.items && employeeDashboardCountsDetails.data.items[0] || {};
  const inputDashboardList = employeeInputDashboardDetails.data.inputList ? employeeInputDashboardDetails.data.inputList : []

  const companiesDetails = useAppSelector((state) => state.inputModule.companiesDetails);
  const associateCompaniesDetails = useAppSelector((state) => state.inputModule.associateCompaniesDetails);
  const locationsDetails = useAppSelector((state) => state.inputModule.locationsDetails);
  const statesDetails = useAppSelector((state) => state.inputModule.statesDetails);
  const companies = companiesDetails && companiesDetails.data.items
  const associateCompanies = associateCompaniesDetails && associateCompaniesDetails.data.items
  const locations = locationsDetails && locationsDetails.data.items
  let states = locations && locations.map((each:any) => {
    const { id, name, code, city }: any = each.location || {};
    const { state } = city || {};
    return {name: state.name, id: state.id}
  })

  states = states && states.filter((each:any, index:any, self:any) => {
    if(index === self.findIndex((t:any) => t.id === each.id)){
      return each
    }
  })

  const loading = [
    employeeBackendCountDetails,
    employeeInputDashboardDetails,
    employeeDashboardCountsDetails,
    companiesDetails,
    associateCompaniesDetails,
    locationsDetails,
    statesDetails
  ].find((details)=>{ return details.status === 'loading' })
  const [downloading,setDownloading]= useState(false);

  const [company, setCompany] = React.useState('');
  const [associate_company, setAssociateCompany] = React.useState('');
  const [stateName, setStateName] = React.useState('');
  const [location, setLocation] = React.useState('');
  const [year, setYear] = React.useState('');
  const [month, setMonth] =  React.useState<any>('');

  
  const [companyName, setCompanyName] = React.useState('');
  const [associate_company_name, setAssociateCompanyName] = React.useState('');
  const [locationName, setLocationName] = React.useState('');

  const [showDashboardDetails, setShowDashboardDetails] = React.useState(true);
  // const [errorLogs, setErrorLogs] = useState<FileDetails[]>([]);

  const handleChangeCompany = (event:any) => {

    const selectedCompanyId = event.target.value as string;
    const selectedCompanyName = getCompanyNameById(selectedCompanyId, companies);
  
   // setShowDashboardDetails(false)
    setAssociateCompany('')
    setStateName('')
    setLocation('')
    setYear('')
    setMonth('')
    setCompany(event.target.value);
    setCompanyName(selectedCompanyName);
  };
  const getCompanyNameById = (id: string, companies: { id: string; name: string; }[]) => {
    for (let i = 0; i < companies.length; i++) {
      if (companies[i].id === id) {
        return companies[i].name;
      }
    }
    return '';
  };

  const handleChangeAssociateCompany = (event:any) => {
    const selectedCompanyId = event.target.value as string;
    const selectedCompanyName = getAssocCompanyNameById(selectedCompanyId, associateCompanies);
  
    //alert(selectedCompanyName);
 //   setShowDashboardDetails(false)
    setLocation('')
    setYear('')
    setMonth('')
    setAssociateCompany(event.target.value);
    setAssociateCompanyName(selectedCompanyName);
  };
  const getAssocCompanyNameById = (id: string, associateCompanies: { id: string; name: string; }[]) => {
    for (let i = 0; i < associateCompanies.length; i++) {
      if (associateCompanies[i].id === id) {
        return associateCompanies[i].name;
      }
    }
    return '';
  };

  const handleChangeStateName = (event:any) => {
  //  setShowDashboardDetails(false)
    setYear('')
    setMonth('')
    setLocation('')
    setStateName(event.target.value);
  }

  const handleChangeLocation = (event:any) => {
    const selectedCompanyId = event.target.value as string;
   // alert(event.target.value);
    const selectedCompanyName = getLocationById(selectedCompanyId, locations);
  
  //  alert(selectedCompanyName);

  //  setShowDashboardDetails(false)
    setYear('')
    setMonth('')
    setLocation(event.target.value);
    setLocationName(selectedCompanyName);
  };

const getLocationById = (id: string, locations: any[]) => {
  for (let i = 0; i < locations.length; i++) {
    if (locations[i].location_id === id) {
      return locations[i].location.name;
    }
  }
  return '';
};

  
  const handleChangeYear = (event:any) => {
  //  setShowDashboardDetails(false)
    setMonth('')
    setYear(event.target.value.toString());
  };
  
  const handleChangeMonth = (event:any) => {
  //  setShowDashboardDetails(false)
    setMonth(event.target.value);
    const dashboardPayloadDefault: any =  { 
      filters: {
        company_id_eq: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
        associate_company_id_eq: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
        location_id_eq: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
        //state_id_eq: '3fa85f64-5717-4562-b3fc-2c963f66afa6', 
        year_eq: 0, 
        month_eq: 'string',
      }
    }

    const dashboardPayload: any =  { 
      filters: {
        company_id_eq: company,
        associate_company_id_eq: associate_company,
        location_id_eq: location,
        //state_id_eq: stateName, 
        year_eq: year, 
        month_eq: event.target.value,
      }
    }

    dispatch(getEmployeeDashboardCounts(dashboardPayload))
    dispatch(getEmployeeInputDashboard(dashboardPayload))
    //dispatch(getEmployeeBackendCount(dashboardPayload))
  };

  useEffect(() => {
    resetEmployeeDashboardCountsDetailsStatus()
    resetEmployeeInputDashboardDetailsStatus()
    resetEmployeeBackendCountDetailsStatus()
    const companiesPayload: any = { ...DEFAULT_OPTIONS_PAYLOAD, filters: { is_parent_eq: true, is_active_eq: true } }
    dispatch(getAllCompaniesDetails(companiesPayload))
  },[])

  useEffect(() => {
    const payload:any = { ...DEFAULT_OPTIONS_PAYLOAD, filters: { is_parent_eq: false, is_active_eq: true, parent_company_id_eq: company } }
    if(company){
      dispatch(getAssociateCompanies(payload))
    }
  }, [company])

  useEffect(() => {
    const payload:any = {
      ...DEFAULT_OPTIONS_PAYLOAD, 
      filters: { 
        company_id_eq: associate_company 
      },
      includes: {
        location: { city: ['state'] }
      },
      include: {
        location: {
          only: ['id','name','code'],
          include: {
            city: {
              only: ['id','name','code'],
              include: {
                state: {
                  only: ['id','name','code']
                }
              }
            }
          }
        }
      },
      sorts: ['location_name asc']
    }
    const statesPayload = {
      ...DEFAULT_OPTIONS_PAYLOAD
    } 

    if(associate_company){
      dispatch(getLocations(payload))
      dispatch(getStates(statesPayload))
    }
  }, [associate_company])

  useEffect(() => {
    
    if(employeeDashboardCountsDetails.status === 'succeeded' || employeeInputDashboardDetails.status === 'succeeded' || employeeBackendCountDetails.status === 'succeeded'){
      //setShowDashboardDetails(true)
    }
    if(employeeDashboardCountsDetails.status === 'succeeded'){
      
    }else if(employeeDashboardCountsDetails.status === 'failed' || employeeInputDashboardDetails.status === 'failed' || employeeBackendCountDetails.status === 'failed'){
      //toast.error(ERROR_MESSAGES.DEFAULT);
      resetEmployeeDashboardCountsDetailsStatus()
      resetEmployeeInputDashboardDetailsStatus()
      resetEmployeeBackendCountDetailsStatus()
    }

  },[employeeBackendCountDetails.status, employeeInputDashboardDetails.status, employeeDashboardCountsDetails.status])

  const yearsList = []
  const currentYear = new Date().getFullYear();

  for (let i = currentYear; i >= 1950; i--) {
    yearsList.push(i)
  }

  const monthList = [
    "January",
    "February",
    "March",  
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const onClickEmployeeUploadPreview = () => {
    navigate(`${getBasePath()}/inputUploads/employeeMasterUpload`, {query: {company, associate_company, location, stateName}});
  }

  const onClickLeaveAvailedPreview = () => {
    navigate(`${getBasePath()}/inputUploads/employeeLeaveAvailedUpload`, { query: { company, associate_company, location,stateName, year, month } });
  }

  const onClickleaveCreditedPreview = () => {
    navigate(`${getBasePath()}/inputUploads/employeeLeaveCreditUpload`, { query: { company, associate_company, location, stateName, year, month } });
  }

  const onClickEmployeeWagePreview = () => {
    navigate(`${getBasePath()}/inputUploads/employeeWageUpload`, { query: { company, associate_company, location, stateName, year, month } });
  }

  const onClickEmployeeAttendancePreview = () => {
   
    navigate(`${getBasePath()}/inputUploads/employeeAttendanceUpload`, { query: { company, associate_company, location, stateName, year, month } });
  }
  

  const fileNames = [
    'FormARegofWages',
     'FormBRegofWages',
     'FormTPart1Regoffines',
     'FormTPart2RegofFines',
     'ESIForm11RegofAccident',
     'POW_Part2RegofDeduction',
     'POW_Part3RegofAdvance',
     'Form_1_RegisterForSuspendedEmployees',
     'Form_Q',
     'MaintainCombinedRegisterofMusterRollFormTPart2',
     'MaintainCombinedRegisterofMusterRollFormTPart1'
   ]

 
  const handleProcessRegisters=async ()=>{
    setDownloading(true);
    let parentcompanyid = company;
    let associatecompanyid = associate_company;
    let stateid=stateName;
    let locationid= location;
    let yearid = year;
    const monthKey = (monthList.findIndex((each) => each === month) + 1).toString();
    const fileUrl = 'https://mafoi.s3.ap-south-1.amazonaws.com/templates/8fde1c23-1927-4c36-a6f1-ef7416e81b6d/Form B.xlsx';

    try {
      // Step 1: Get the access token
      const params = new URLSearchParams();
      params.append('grant_type', 'password');
      params.append('username', 'admin');
      params.append('password', 'admin');

      const tokenResponse = await axios.post('https://ezycomp.antworx.com/app/oauth/token', params.toString(), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': 'Basic ' + btoa('client:secret'),
          'User-Agent': 'PostmanRuntime/7.39.0',
          'Accept-Encoding': 'gzip, deflate, br',
          'Connection': 'keep-alive'
        }
      });

      //console.log(tokenResponse.data);

      const accessToken = tokenResponse.data.access_token;

      for (const filename of fileNames) {

        let formResponseUrl= "";
      let fileUrl="";
        if(filename == 'FormBRegofWages'){
          fileUrl='https://mafoi.s3.ap-south-1.amazonaws.com/templates/8fde1c23-1927-4c36-a6f1-ef7416e81b6d/Form B.xlsx'
          formResponseUrl='https://ezycomp.antworx.com/app/rest/services/bws_Reporting_Controller/fileFormBRegofWages';
        }
        else if(filename=='FormARegofWages'){
          fileUrl='https://mafoi.s3.ap-south-1.amazonaws.com/templates/b21fb1d8-a634-4420-adc5-14361cd94790/Form A - reg of wages.xlsx'
          formResponseUrl='https://ezycomp.antworx.com/app/rest/services/bws_Reporting_Controller/fileFormARegofWages';
        }
        else if(filename=='FormTPart1Regoffines'){
          fileUrl='https://mafoi.s3.ap-south-1.amazonaws.com/templates/162c6d84-0e62-4cc7-8281-b8fac56e42d1/form T-Part-1.xlsx'
formResponseUrl='https://ezycomp.antworx.com/app/rest/services/bws_Reporting_Controller/fileFormTPart1Regoffines';
        }
        else if(filename=='FormTPart2RegofFines'){
          fileUrl='https://mafoi.s3.ap-south-1.amazonaws.com/templates/ff9fb10f-14eb-402f-b094-1224267b0101/Form T-Part 2.xlsx'
        formResponseUrl='https://ezycomp.antworx.com/app/rest/services/bws_Reporting_Controller/fileFormTPart2RegofFines';
        }
        else if(filename=='ESIForm11RegofAccident'){
            fileUrl='https://mafoi.s3.ap-south-1.amazonaws.com/templates/919ccacd-e50d-4906-ad74-28aeb8fca1a7/ESI_Form 11_Reg of Accident.xlsx'
          formResponseUrl='https://ezycomp.antworx.com/app/rest/services/bws_Reporting_Controller/fileESIForm11RegofAccident';
        }
        else if(filename=='POW_Part2RegofDeduction'){
          fileUrl='https://mafoi.s3.ap-south-1.amazonaws.com/templates/96d650d7-d1e1-476d-8728-385c9ed5a2cc/POW Form 2 for Deduction.xlsx'
          formResponseUrl='https://ezycomp.antworx.com/app/rest/services/bws_Reporting_Controller/filePOW_Part2RegofDeduction';
        }
        else if(filename=='POW_Part3RegofAdvance'){
          fileUrl='https://mafoi.s3.ap-south-1.amazonaws.com/templates/f8c6ebf9-9f57-413d-a22b-c6b76e3c62a2/POW Form III Reg of Advance  .xlsx'
        formResponseUrl='https://ezycomp.antworx.com/app/rest/services/bws_Reporting_Controller/filePOW_Part3RegofAdvance';
        }
        else if(filename=='Form_1_RegisterForSuspendedEmployees'){
          fileUrl='https://mafoi.s3.ap-south-1.amazonaws.com/templates/e5484c2d-884b-47b3-9e42-6392377f490a/Form 1.xlsx'
        formResponseUrl='https://ezycomp.antworx.com/app/rest/services/bws_Reporting_Controller/fileForm_1_RegisterForSuspendedEmployees';
        }
        else if(filename=='Form_Q'){
          fileUrl='https://mafoi.s3.ap-south-1.amazonaws.com/templates/5eb524bb-04c4-4f39-b15d-fe462eb67b50/Form Q.xlsx'
          formResponseUrl='https://ezycomp.antworx.com/app/rest/services/bws_Reporting_Controller/fileForm_Q';
        }
        else if(filename=='MaintainCombinedRegisterofMusterRollFormTPart2'){
          fileUrl='https://mafoi.s3.ap-south-1.amazonaws.com/templates/ff9fb10f-14eb-402f-b094-1224267b0101/Form T-Part 2.xlsx'
        formResponseUrl='https://ezycomp.antworx.com/app/rest/services/bws_Reporting_Controller/fileMaintainCombinedRegisterofMusterRollFormTPart2';
        }
        else if(filename=='MaintainCombinedRegisterofMusterRollFormTPart1'){
            fileUrl='https://mafoi.s3.ap-south-1.amazonaws.com/templates/162c6d84-0e62-4cc7-8281-b8fac56e42d1/form T-Part-1.xlsx'
          formResponseUrl='https://ezycomp.antworx.com/app/rest/services/bws_Reporting_Controller/fileMaintainCombinedRegisterofMusterRollFormTPart1';
          }
        else{
          formResponseUrl='https://ezycomp.antworx.com/app/rest/services/bws_Reporting_Controller/fileFormBRegofWages';
        }
          
console.log('filrUrl',fileUrl);        
console.log('formResonseUrl',formResponseUrl);
      const formResponse = await axios.post(
      formResponseUrl,
        {
          companyID: company,
          associatedCompanyID: associate_company,
          state_id: stateName,
          locationID: location,
          formURL: fileUrl,
          year: year,
          month: "January"
        },
        {
          headers: {
            'Authorization': `Bearer ${accessToken}`
          }
        }
      );
    
  

      console.log(formResponse.data.body);

      const filedownloadresponseURL= formResponse.data.body;
     // alert('filedownloadresponseURL : ' +filedownloadresponseURL);

    
       const fileRefMatch = filedownloadresponseURL.match(/fileRef=([^&]+)/);
       if (!fileRefMatch) {
         throw new Error('fileRef not found in form response');
       }
       const fileRef = decodeURIComponent(fileRefMatch[1]);
       console.log('fileRef', fileRef);

       const fileDownloadResponse = await axios.get('https://ezycomp1.buoyantworx.com/app/rest/files', {
        headers: {
          'Authorization': `Bearer ${accessToken}`
        },
        params: {
          fileRef: fileRef
        },
        responseType: 'blob' // Ensure binary data handling
      });

      // Verify the content of the response
      console.log('fileDownloadResponse', fileDownloadResponse);

      // Step 4: Create a link to download the file
      const url = window.URL.createObjectURL(new Blob([fileDownloadResponse.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
      const link = document.createElement('a');
      link.href = url;
      // link.setAttribute('download', `${filename}.xlsx`);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      toast.success(`${filename} downloaded successfully`);

    }
    setDownloading(false);
  } catch (error) {
    console.error('Error processing registers:', error);
    if (axios.isAxiosError(error)) {
      console.error('Axios error details:', {
        message: error.message,
        name: error.name,
        code: error.code,
        config: error.config,
        request: error.request,
        response: error.response ? {
          data: error.response.data,
          status: error.response.status,
          headers: error.response.headers,
        } : null,
      });
    toast.error("Error in downloading files");
    setDownloading(false);
  }
}

  }


  const handleProcessRegisters2=async ()=>{
    let fileUrl = '';
    if(stateName == '912da48d-630f-4cdb-9b24-d27cda14fc03'){
      fileUrl = 'https://ezycomp1.buoyantworx.com/app/rest/services/bws_TN_Reporting_Controller/getAllTamilNaduForms';
    }
    else if(stateName == '59b24896-1f55-4037-b631-c699dd9fd2bc')
      {
        fileUrl = 'https://ezycomp1.buoyantworx.com/app/rest/services/bws_Reporting_Controller/getAllKarnatakaForms';
    }
    else if(stateName == '827e4dd8-079e-4c4f-a7ef-783c52926226')
      {
        fileUrl = 'https://ezycomp1.buoyantworx.com/app/rest/services/BWS_AP_Controller/getAllAndraPradeshForms';
    }
    else if(stateName == '75144ed9-1a78-4a0d-8d69-6519a9908dc3')
      {
        fileUrl = 'https://ezycomp1.buoyantworx.com/app/rest/services/BWS_Telangana_Controller/getAllTelanganaForms';
    }
    else if(stateName == '6ece4005-dff4-471b-aade-8139bba6b5e2')
      {
        fileUrl = 'https://ezycomp1.buoyantworx.com/app/rest/services/bws_Kerala_Controller/getAllKeralaForms';
    }
    else if(stateName == 'bcc02dfd-dc75-46f0-9097-9645be70c457')
      {
        fileUrl = 'https://ezycomp1.buoyantworx.com/app/rest/services/bws_Maharastra_Controller/getAllMaharastraForms';
    }
    else if(stateName == '334b472a-fbc6-40a5-a7a6-0960fd89fab8')
      {
        fileUrl = 'https://ezycomp1.buoyantworx.com/app/rest/services/bws_Rajastan_Controller/getAllRajastanForms';
    }
    else if(stateName == '958d51e8-9dda-47cf-a537-1b471026b0c6')
      {
        fileUrl = 'https://ezycomp1.buoyantworx.com/app/rest/services/bws_Gujarath_Controller/getAllGujarathForms';
    }
    else if(stateName == '3995e3f5-718c-420b-8fc3-636362b0f592')
      {
        fileUrl = 'https://ezycomp1.buoyantworx.com/app/rest/services/bws_Punjab_Controller/getAllPunjabForms';
    }
    else if(stateName == '2bce7366-0e00-4f25-889c-46e583920dc4')
      {
        fileUrl = 'https://ezycomp1.buoyantworx.com/app/rest/services/bws_MadhyaPradesh_Controller/getAllMadhyaPradeshForms';
    }
    else if(stateName == 'f1ebf4e0-4060-493c-b632-af8895082ac5')
      {
        fileUrl = 'https://ezycomp1.buoyantworx.com/app/rest/services/bws_Chattisgarh_Controller/getAllChattisgarhForms';
    }
    else if(stateName == 'e74e0987-b17a-4ea8-a90c-c83545a84083')
      {
        fileUrl = 'https://ezycomp1.buoyantworx.com/app/rest/services/bws_Chandigarh_Controller/getAllChandigarhForms';
    }
    else if(stateName == '635d88d7-b89e-4a40-9e4c-569c6ea2a5c0')
      {
        fileUrl = 'https://ezycomp1.buoyantworx.com/app/rest/services/bws_Haryana_Controller/getAllHaryanaForms';
    }
    else if(stateName == 'b4d010ce-1b8c-4547-bfee-e9fddde05ce4')
      {
        fileUrl = 'https://ezycomp1.buoyantworx.com/app/rest/services/bws_Delhi_Controller/getAllDelhiForms';
    }
    else if(stateName == '7d710181-1a02-4d56-923c-0ba4b5b9f59f')
      {
        fileUrl = 'https://ezycomp1.buoyantworx.com/app/rest/services/bws_UttarPradesh_Controller/getAllUttarPradeshForms';
    }
    else if(stateName == '0d8f1621-29d5-4141-9c7e-3e93084d05b5')
      {
        fileUrl = 'https://ezycomp1.buoyantworx.com/app/rest/services/bws_Goa_Controller/getAllGoaForms';
    }
    else if(stateName == '3e163775-c0b8-48f0-9097-f32eb50b0f55')
      {
        fileUrl = 'https://ezycomp1.buoyantworx.com/app/rest/services/bws_PondiCherry_Controller/getAllPondiCherryForms';
    }
    else if(stateName == '12d45b68-0ed1-40ff-b268-bd30a814d484')
      {
        fileUrl = 'https://ezycomp1.buoyantworx.com/app/rest/services/bws_Bihar_Controller/getAllBiharForms';
    }
    else if(stateName == '97c92fbd-40b0-4d11-8557-8ded6d0a06ab')
      {
        fileUrl = 'https://ezycomp1.buoyantworx.com/app/rest/services/bws_Assam_Controller/getAllAssamForms';
    }
    else if(stateName == '5bcd6f97-3065-4f62-9a02-17236ad9abe5')
      {
        fileUrl = 'https://ezycomp1.buoyantworx.com/app/rest/services/bws_Odisha_Controller/getAllOdishaForms';
    }
    else if(stateName == 'aff2d7e5-8619-4887-9865-df2164606b0f')
      {
        fileUrl = 'https://ezycomp1.buoyantworx.com/app/rest/services/bws_WestBengal_Controller/getAllWestBengalForms';
    }
    else{
      toast.error("State was Not Configured");
      return 
    }
    setDownloading(true);
    try {
      // Step 1: Get the access token
      const params = new URLSearchParams();
      params.append('grant_type', 'password');
      params.append('username', 'admin');
      params.append('password', 'admin');

      const tokenResponse = await axios.post('https://ezycomp1.buoyantworx.com/app/oauth/token', params.toString(), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': 'Basic ' + btoa('client:secret'),
          'User-Agent': 'PostmanRuntime/7.39.0',
          'Accept-Encoding': 'gzip, deflate, br',
          'Connection': 'keep-alive'
        }
      });

      console.log(tokenResponse.data);

      const accessToken = tokenResponse.data.access_token;

    const formResponse = await axios.post(
      fileUrl,
      {
        companyID: company,
        associatedCompanyID: associate_company,
        locationID: location,
        stateID: stateName,
        year: year,
        month: month
      },
      {
        headers: {
          'Content-Type': 'application/xml', // Ensure the Content-Type matches the cURL request
          'Authorization': `Bearer ${accessToken}`,
          'Cookie': 'JSESSIONID=7D50AD68329785DF351FE423A440A45E; JSESSIONID=7CE95831E685227D3FED93436D4A7136',
          'Connection': 'keep-alive'
        }
      }
    );
    
  

      console.log(formResponse.data.body);

      //const filedownloadresponseURL= formResponse.data.body;

      let filedownloadresponseURL = formResponse.data.body; // The original URL
const oldBaseURL = "https://ezycomp1.buoyantworx.com/rest/";
const newBaseURL = "https://ezycomp1.buoyantworx.com/app/rest/";
filedownloadresponseURL = filedownloadresponseURL.replace(oldBaseURL, newBaseURL);

// Log the modified URL to debug
console.log("Modified URL:", filedownloadresponseURL);

       const fileDownloadResponse = await axios.get(filedownloadresponseURL, {
        headers: {
          'Authorization': `Bearer ${accessToken}`
        },
        
        responseType: 'blob' // Ensure binary data handling
      });

      // Verify the content of the response
      console.log('fileDownloadResponse', fileDownloadResponse);

      const url = window.URL.createObjectURL(new Blob([fileDownloadResponse.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
      const link = document.createElement('a');
      link.href = url;
      let zipfilename = associate_company_name+'_'+locationName+'_'+year+'_'+month+'.zip';


      link.setAttribute('download', zipfilename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      toast.success(`Registers Generated successfully`); 
    setDownloading(false);
  } catch (error) {
    console.error('Error processing registers:', error);
    if (axios.isAxiosError(error)) {
      console.error('Axios error details:', {
        message: error.message,
        name: error.name,
        code: error.code,
        config: error.config,
        request: error.request,
        response: error.response ? {
          data: error.response.data,
          status: error.response.status,
          headers: error.response.headers,
        } : null,
      });
    toast.error("Error in downloading files");
    setDownloading(false);
  }
}

  }


  const DownloadErrorLogs=()=>{
    // alert(company);
    // alert(associate_company);
    // alert(stateName);
    // alert(location);
    // alert(year);
    // alert(month);
    const formData = new FormData();
    
    formData.append('CompanyId',company );
    formData.append('AssociateCompanyId', associate_company)
    formData.append('LocationId', location)
    formData.append('StateId', stateName)
    formData.append('Year', year)
    formData.append('Month', month)

    console.log(formData);

    dispatch(getErrorLogs(formData))
  }

  interface FileDetails {
    filePath: string;
    configType: string;
  }
  
  interface ApiResponse {
    status: string;
    list: FileDetails[];
    message: string | null;
  }

  const onclickDownload=(file:any)=>{
    //alert(each.registerUrl);
    const url = file.filePath;

   // alert(url);
     
  const link = document.createElement('a');
  link.href = url;
  
 
  link.download = url.split('/').pop(); // Use the file name from the URL


  document.body.appendChild(link);

  link.click();

  document.body.removeChild(link);
  }

  // Function to handle the download of all files
const handleFileDownloads = async (files: FileDetails[]) => {
  for (const file of files) {
   // alert(file.filePath);
    await onclickDownload(file);
  }
};




  useEffect(() => {
    if (getErrorLogDetails.status === 'succeeded') {
      (async () => {
     //   alert('429 configuploadstatus hitted');
       // alert(getErrorLogDetails.data.status);

        if (getErrorLogDetails.data.status === 'Success') {
          const files = getErrorLogDetails.data.list;
          await handleFileDownloads(files);
        }

        if (getErrorLogDetails.data.status === 'Failure') {
          toast.error('No files found');
        }
      })();
    } else if (getErrorLogDetails.status === 'failed') {
      toast.error('An error occurred while fetching data.');
      dispatch(resetErrorLogsDetailsStatus());
    }
  }, [getErrorLogDetails.status, dispatch]);

  
  


  return (
    <div style={{ backgroundColor:'#ffffff', minHeight:'100vh'}}>
      {loading ? <PageLoader>Loading...</PageLoader> : 
      <div>
        {downloading ? <PageLoader>Processing Registers...</PageLoader> :

        <div style={{paddingBottom:'100px'}}>

            {/* Filter Box*/}
            <Box sx={{paddingX: '20px', paddingY:'10px',}}>
              <div style={{backgroundColor:'#E2E3F8', padding:'20px', borderRadius:'6px', boxShadow: '0px 6px 10px #CDD2D9'}}>
                  <div style={{display:'flex', justifyContent:'space-between', marginBottom:'15px', marginTop:'10px'}}>
                      <h5 style={{ font: 'normal normal normal 32px/40px Calibri' }}>Register Module</h5>
                  </div>
                  <div style={{display:'flex'}}>

                    <Box sx={{width:'100%', mr:1}}>
                      <Typography mb={1}>Company</Typography>
                      <FormControl sx={{ width:'100%', maxWidth:'200px', backgroundColor:'#ffffff', borderRadius:'5px'}} size="small">
                        <Select
                          sx={{'.MuiOutlinedInput-notchedOutline': { border: 0 }}}
                          value={company}
                          displayEmpty
                      onChange={handleChangeCompany}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxHeight: 200,
                            width: 230,
                            marginTop: "3px"
                          }
                        }
                      }}
                        >
                          <MenuItem disabled sx={{display:'none'}} value="">
                            Select Company
                          </MenuItem>
                          {companies && companies.map((each:any) => {
                              return <MenuItem sx={{width:'240px', whiteSpace:'initial'}} value={each.id}>{each.name}</MenuItem>
                          })}
                        </Select>
                      </FormControl>
                    </Box>

                    <Box sx={{width:'100%', mr:1}}>
                      <Typography mb={1}>Associate Company</Typography>
                      <FormControl sx={{ width:'100%', maxWidth:'200px', backgroundColor:'#ffffff', borderRadius:'5px'}} size="small">
                        <Select
                          sx={{'.MuiOutlinedInput-notchedOutline': { border: 0 }}}
                          displayEmpty
                          value={associate_company}
                          disabled={!company}
                      onChange={handleChangeAssociateCompany}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxHeight: 200,
                            width: 230,
                            marginTop: "3px"
                          }
                        }
                      }}
                        >
                          <MenuItem disabled sx={{display:'none'}} value="">
                            Select Associate Company
                          </MenuItem>
                          {associateCompanies && associateCompanies.map((each:any) => {
                            return <MenuItem sx={{ width: '240px', whiteSpace: 'initial' }} value={each.id}>{each.name}</MenuItem>
                          })}
                        </Select>
                      </FormControl>
                    </Box>

                    <Box sx={{width:'100%', mr:1}}>
                      <Typography mb={1}>States</Typography>
                      <FormControl sx={{ width:'100%', maxWidth:'200px', backgroundColor:'#ffffff', borderRadius:'5px'}} size="small">
                        <Select
                          sx={{'.MuiOutlinedInput-notchedOutline': { border: 0 }}}
                          displayEmpty
                          value={stateName}
                          disabled={!associate_company}
                      onChange={handleChangeStateName}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxHeight: 200,
                            width: 230,
                            marginTop: "3px"
                          }
                        }
                      }}
                        >
                          <MenuItem disabled sx={{display:'none'}} value="">
                            Select State
                          </MenuItem>
                          {states && states.map((each:any) => {
                            return <MenuItem sx={{ width: '240px', whiteSpace: 'initial' }} value={each.id}>{each.name}</MenuItem>
                          })}
                        </Select>
                      </FormControl>
                    </Box>

                    <Box sx={{width:'100%', mr:1}}>
                      <Typography mb={1}>Location</Typography>
                      <FormControl sx={{ width:'100%', maxWidth:'200px', backgroundColor:'#ffffff', borderRadius:'5px'}} size="small">
                        <Select
                          sx={{'.MuiOutlinedInput-notchedOutline': { border: 0 }}}
                          displayEmpty
                          value={location}
                          disabled={!stateName}
                      onChange={handleChangeLocation}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxHeight: 200,
                            width: 230,
                            marginTop: "3px"
                          }
                        }
                      }}
                        >
                          <MenuItem disabled sx={{display:'none'}} value="">
                            Select Location
                          </MenuItem>
                          {locations && locations.map((each:any) => {
                            const { id, name, code, city }: any = each.location || {};
                            const { state } = city || {};
                            if(state.id === stateName){
                              return <MenuItem sx={{ width: '240px', whiteSpace: 'initial' }} value={each.location_id}>{`${name} (${state.code}-${city.code}-${code})`}</MenuItem>
                            }
                          })}
                        </Select>
                      </FormControl>
                    </Box>

                    <Box sx={{width:'100%', mr:1}}>
                      <Typography mb={1}>Year</Typography>
                      <FormControl sx={{ width:'100%', maxWidth:'200px', backgroundColor:'#ffffff', borderRadius:'5px'}} size="small">
                        <Select
                          sx={{'.MuiOutlinedInput-notchedOutline': { border: 0 }}}
                          displayEmpty
                          value={year}
                          disabled={!location}
                      onChange={handleChangeYear}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxHeight: 200,
                            width: 150,
                            marginTop: "3px"
                          }
                        }
                      }}
                        >
                          <MenuItem disabled sx={{display:'none'}} value="">
                            Select Year
                          </MenuItem>
                          {yearsList && yearsList.map((each:any) => 
                            <MenuItem sx={{ width: '240px', whiteSpace: 'initial' }} value={each}>{each}</MenuItem>
                          )}
                        </Select>
                      </FormControl>
                    </Box>

                    <Box sx={{width:'100%', mr:1}}>
                      <Typography mb={1}>Month</Typography>
                      <FormControl sx={{ width:'100%', maxWidth:'200px', backgroundColor:'#ffffff', borderRadius:'5px'}} size="small">
                        <Select
                          sx={{'.MuiOutlinedInput-notchedOutline': { border: 0 }}}
                          displayEmpty
                          value={month}
                          disabled={!year}
                      onChange={handleChangeMonth}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxHeight: 200,
                            width: 150,
                            marginTop: "3px"
                          }
                        }
                      }}
                        >
                          <MenuItem disabled sx={{display:'none'}} value="">
                            Select Month
                          </MenuItem>
                          {monthList && monthList.map((each:any) => 
                            <MenuItem sx={{ width: '240px', whiteSpace: 'initial' }} value={each}>{each}</MenuItem>
                          )}
                        </Select>
                      </FormControl>
                    </Box>
                  </div>
              </div>
            </Box>

            {/* Counts Box*/}
            {showDashboardDetails && <Box sx={{paddingX: '20px', mt:2, display:'flex', justifyContent:'space-between'}}>
                
                {/* Employees Count*/}
                <Box sx={{width: '40%', background:'#EFEBFE 0% 0% no-repeat padding-box', borderRadius:'10px', border:'1px solid #E1DEEF'}}>

                    <Box sx={{ padding:'10px', display:'flex', justifyContent:'space-between'}}>
                      <Typography sx={{font: 'normal normal normal 22px/32px Calibri', color:'#0F105E'}}>Employees</Typography>
                      <Typography sx={{font: 'normal normal bold 22px/32px Calibri', color:'#0F105E'}}>{employeeCounts.total_employees ? employeeCounts.total_employees : "NA"}</Typography> 
                    </Box>

                    <Box sx={{borderBottom:'1px solid #707070', opacity:'0.1'}}></Box>

                    <Box sx={{display:'flex', justifyContent:'space-between'}}>
                          <Box sx={{padding:'10px'}}>
                            <Typography sx={{font: 'normal normal normal 22px/32px Calibri', color:'#6F6F6F'}}>New</Typography>
                            <Typography sx={{font: 'normal normal bold 22px/32px Calibri', color:'#0F105E'}}>{employeeCounts.employee_new_count ? employeeCounts.employee_new_count : "NA"}</Typography> 
                          </Box>
                          <Box sx={{borderRight:'1px solid #707070', opacity:'0.1'}}></Box>

                          <Box sx={{padding:'10px'}}>
                            <Typography sx={{font: 'normal normal normal 22px/32px Calibri', color:'#6F6F6F'}}>Existing</Typography>
                            <Typography sx={{font: 'normal normal bold 22px/32px Calibri', color:'#0F105E'}}>{employeeCounts.employee_existing_count ? employeeCounts.employee_existing_count : "NA"}</Typography> 
                          </Box>
                          <Box sx={{borderRight:'1px solid #707070', opacity:'0.1'}}></Box>

                          <Box sx={{padding:'10px'}}>
                            <Typography sx={{font: 'normal normal normal 22px/32px Calibri', color:'#6F6F6F'}}>Resigned</Typography>
                            <Typography sx={{font: 'normal normal bold 22px/32px Calibri', color:'#0F105E'}}>{employeeCounts.employee_resigned_count ? employeeCounts.employee_resigned_count : "NA"}</Typography> 
                          </Box>
                          <Box sx={{borderRight:'1px solid #707070', opacity:'0.1'}}></Box>

                          <Box sx={{padding:'10px'}}>
                            <Typography sx={{font: 'normal normal normal 22px/32px Calibri', color:'#6F6F6F'}}>Male</Typography>
                            <Typography sx={{font: 'normal normal bold 22px/32px Calibri', color:'#0F105E'}}>{employeeCounts.male_count ? employeeCounts.male_count : "NA" }</Typography> 
                          </Box>
                          <Box sx={{borderRight:'1px solid #707070', opacity:'0.1'}}></Box>

                          <Box sx={{padding:'10px'}}>
                            <Typography sx={{font: 'normal normal normal 22px/32px Calibri', color:'#6F6F6F'}}>Female</Typography>
                            <Typography sx={{font: 'normal normal bold 22px/32px Calibri', color:'#0F105E'}}>{employeeCounts.female_count ? employeeCounts.female_count : "NA"}</Typography> 
                          </Box>
                          <Box sx={{borderRight:'1px solid #707070', opacity:'0.1'}}></Box>

                    </Box>
                </Box>

                {/* Leaves Count*/}
                <Box sx={{width: '29%', background:'#EAF7FF 0% 0% no-repeat padding-box', borderRadius:'10px', border:'1px solid #E1DEEF'}}>

                    <Box sx={{ padding:'10px', display:'flex', justifyContent:'space-between'}}>
                      <Typography sx={{font: 'normal normal normal 22px/32px Calibri', color:'#0F105E'}}>Leave and Attendance</Typography>
                    </Box>
                    <Box sx={{borderBottom:'1px solid #707070', opacity:'0.1'}}></Box>

                    <Box sx={{display:'flex', justifyContent:'space-between'}}>
                          <Box sx={{padding:'10px'}}>
                            <Typography sx={{font: 'normal normal normal 22px/32px Calibri', color:'#6F6F6F'}}>Credit</Typography>
                            <Typography sx={{font: 'normal normal bold 22px/32px Calibri', color:'#0F105E'}}>{employeeCounts.leave_credit_count ? employeeCounts.leave_credit_count : "NA"}</Typography> 
                          </Box>
                          <Box sx={{borderRight:'1px solid #707070', opacity:'0.1'}}></Box>

                          <Box sx={{padding:'10px'}}>
                            <Typography sx={{font: 'normal normal normal 22px/32px Calibri', color:'#6F6F6F'}}>Availed</Typography>
                            <Typography sx={{font: 'normal normal bold 22px/32px Calibri', color:'#0F105E'}}>{employeeCounts.leave_update_count ? employeeCounts.leave_update_count : "NA"}</Typography> 
                          </Box>
                          <Box sx={{borderRight:'1px solid #707070', opacity:'0.1'}}></Box>

                          <Box sx={{padding:'10px'}}>
                            <Typography sx={{font: 'normal normal normal 22px/32px Calibri', color:'#6F6F6F'}}>Attendance</Typography>
                            <Typography sx={{font: 'normal normal bold 22px/32px Calibri', color:'#0F105E'}}>{employeeCounts.employee_attendence ? employeeCounts.employee_attendence : "NA"}</Typography> 
                          </Box>
                          <Box sx={{borderRight:'1px solid #707070', opacity:'0.1'}}></Box>

                    </Box>
                </Box>

                {/* Wages Count*/}
                <Box sx={{width: '29%', background:'#E7EEF7 0% 0% no-repeat padding-box', borderRadius:'10px', border:'1px solid #E1DEEF'}}>

                  <Box sx={{ padding:'10px', display:'flex', justifyContent:'space-between'}}>
                    <Typography sx={{font: 'normal normal normal 22px/32px Calibri', color:'#0F105E'}}>Wage</Typography>
                     {/* <Typography sx={{font: 'normal normal bold 22px/32px Calibri', color:'#0F105E'}}>{employeeCounts.wageTotal ? employeeCounts.wageTotal : "NA"}</Typography>   */}
                     <Typography sx={{font: 'normal normal bold 22px/32px Calibri', color:'#0F105E'}}>{(employeeCounts.employee_existing_count+employeeCounts.wage_new_count+employeeCounts.wage_resigned_count) ? (employeeCounts.employee_existing_count+employeeCounts.wage_new_count+employeeCounts.wage_resigned_count) : "NA"}</Typography>  
                  </Box>
                  <Box sx={{borderBottom:'1px solid #707070', opacity:'0.1'}}></Box>

                  <Box sx={{display:'flex', justifyContent:'space-between'}}>
                        <Box sx={{padding:'10px'}}>
                          <Typography sx={{font: 'normal normal normal 22px/32px Calibri', color:'#6F6F6F'}}>New</Typography>
                          <Typography sx={{font: 'normal normal bold 22px/32px Calibri', color:'#0F105E'}}>{employeeCounts.wage_new_count ? employeeCounts.wage_new_count : "NA"}</Typography> 
                        </Box>
                        <Box sx={{borderRight:'1px solid #707070', opacity:'0.1'}}></Box>

                        <Box sx={{padding:'10px'}}>
                          <Typography sx={{font: 'normal normal normal 22px/32px Calibri', color:'#6F6F6F'}}>Resigned</Typography>
                          <Typography sx={{font: 'normal normal bold 22px/32px Calibri', color:'#0F105E'}}>{employeeCounts.wage_resigned_count ? employeeCounts.wage_resigned_count : "NA"}</Typography> 
                        </Box>
                        <Box sx={{borderRight:'1px solid #707070', opacity:'0.1'}}></Box>

                        <Box sx={{padding:'10px'}}>
                          <Typography sx={{font: 'normal normal normal 22px/32px Calibri', color:'#6F6F6F'}}>Existing</Typography>
                          <Typography sx={{font: 'normal normal bold 22px/32px Calibri', color:'#0F105E'}}>{employeeCounts.employee_existing_count ? employeeCounts.employee_existing_count : "NA"}</Typography> 
                        </Box>
                        <Box sx={{borderRight:'1px solid #707070', opacity:'0.1'}}></Box>

                        {/* <Box sx={{padding:'10px'}}>
                          <Typography sx={{font: 'normal normal normal 22px/32px Calibri', color:'#6F6F6F'}}>F & F</Typography>
                           <Typography sx={{font: 'normal normal bold 22px/32px Calibri', color:'#0F105E'}}>{employeeCounts.wage_fand_f_count ? employeeCounts.wage_fand_f_count : "NA"}</Typography>  
                        </Box> */}
                        <Box sx={{borderRight:'1px solid #707070', opacity:'0.1'}}></Box>

                  </Box>
                </Box>

            </Box>}

            {/* Status Box */}
            {showDashboardDetails && <Box sx={{paddingX: '20px', color:'#F3F4F8', mt:2, }}>
              <Box sx={{display:'flex', justifyContent:'space-between', width:'100%', padding:'15px', background:'#EFEBFE 0% 0% no-repeat padding-box', boxShadow:'0px 6px 10px #00000029', borderRadius:'8px'}}>
                
                {/* Input Box */}
                <Box sx={{width:'25%', display:'flex', flexDirection:'column', alignItems:'center'}}>
                  <Box sx={{padding:'20px', width:'100%', height:'330px', background:'#1364FF 0% 0% no-repeat padding-box', boxShadow:'0px 6px 10px #00000029', borderRadius:'10px'}}>
                      
                      <Box sx={{display:'flex', alignItems:'center'}}>
                        <FaRegKeyboard style={{fontSize:'28px'}}/>
                        <Typography ml={2}> Input</Typography>
                      </Box>
                      
                      {inputDashboardList.length > 0 ? 
                        inputDashboardList.map((each:any) => {
                            let redirectFunction = onClickEmployeeAttendancePreview
                            if(each.inputFiletype === 'Employee'){
                              redirectFunction = onClickEmployeeUploadPreview
                            }else if(each.inputFiletype === 'Leave availed'){
                              redirectFunction = onClickLeaveAvailedPreview
                            }else if(each.inputFiletype === 'Leave credit'){
                              redirectFunction = onClickleaveCreditedPreview
                            }else if(each.inputFiletype === 'Employee Wage'){
                              redirectFunction = onClickEmployeeWagePreview
                            }else if(each.inputFiletype === 'Employee Attendance'){
                              redirectFunction = onClickEmployeeAttendancePreview
                            }

                            return (
                              <Box mt={1} sx={{display:'flex', justifyContent:'space-between', background:'#24C58A4D 0% 0% no-repeat padding-box', borderRadius:'8px', border:'1px solid #24C58A'}}>
                                                  <Typography padding={'8px'}> {each.inputFiletype}</Typography>
                                                  {each.status === 'Completed' ? 
                                                    <Box sx={{display:'flex'}}>
                                                      <Box sx={{padding:'8px', background:'#05B474 0% 0% no-repeat padding-box', borderRadius:'8px', mr:1}}>
                                                        <FaCheck style={{fontSize:'20px'}}/>
                                                      </Box>
                                                      <Box sx={{padding:'8px', cursor:'pointer', background:'#0654AD 0% 0% no-repeat padding-box', borderRadius:'8px'}} onClick={redirectFunction}>
                                                        <FaRegEye style={{fontSize:'20px'}}/>
                                                      </Box>
                                                    </Box>
                                                    : 
                                                    <Box sx={{display:'flex'}}>
                                                      <Box sx={{padding:'8px', background:'#F11919 0% 0% no-repeat padding-box', borderRadius:'8px', mr:1}}>
                                                        <IoMdClose style={{fontSize:'20px'}}/>
                                                      </Box>
                                                      <Box sx={{padding:'8px', background:'#0654AD 0% 0% no-repeat padding-box', borderRadius:'8px'}}>
                                                        <FaCloudDownloadAlt style={{fontSize:'20px'}}/>
                                                      </Box>
                                                    </Box>
                                                  }
                                                </Box>
                            )
                        }) 
                        :
                        <Box>
                        <Typography mt={10} ml={12}> NA</Typography>
                        </Box>
                      }

                     
                  </Box>
                  
                 

                </Box>

                {/* Check list Box */}
                <Box sx={{width:'24%', display:'flex', flexDirection:'column', alignItems:'center'}}>
                  
                  <Box sx={{padding:'20px', width:'100%', height:'330px', background:'#222385 0% 0% no-repeat padding-box', boxShadow:'0px 6px 10px #00000029', borderRadius:'10px'}}>
                      <Box sx={{display:'flex', alignItems:'center'}}>
                        <FaRegCircleCheck style={{fontSize:'28px'}}/>
                        <Typography ml={2}> Check List</Typography>
                      </Box>

                      <Box mt={2} sx={{display:'flex', justifyContent:'space-between', alignItems:'center', background:'#055FC64D 0% 0% no-repeat padding-box', borderRadius:'8px', border:'1px solid #055FC6'}}>
                        <Typography padding={'8px'}> Employee Pan ( {employeeCounts.employee_pan_count ? employeeCounts.employee_pan_count : "0" } nos )</Typography>
                        <Box sx={{padding:'8px', background:'#0654AD 0% 0% no-repeat padding-box', borderRadius:'8px'}}>
                          <FaCloudUploadAlt style={{fontSize:'20px'}}/>
                        </Box>
                      </Box>
                      
                      <Box mt={1} sx={{display:'flex', justifyContent:'space-between', alignItems:'center', background:'#055FC64D 0% 0% no-repeat padding-box', borderRadius:'8px', border:'1px solid #055FC6'}}>
                        <Typography padding={'8px'}> Aadhar ( {employeeCounts.employee_aadhar_count ? employeeCounts.employee_aadhar_count : "0" } nos )</Typography>
                        <Box sx={{padding:'8px', background:'#0654AD 0% 0% no-repeat padding-box', borderRadius:'8px'}}>
                          <FaCloudUploadAlt style={{fontSize:'20px'}}/>
                        </Box>
                      </Box>

                      <Box mt={1} sx={{display:'flex', justifyContent:'space-between', alignItems:'center', background:'#055FC64D 0% 0% no-repeat padding-box', borderRadius:'8px', border:'1px solid #055FC6'}}>
                        <Typography padding={'8px'}> ESIC ( {employeeCounts.employee_esi_count ? employeeCounts.employee_esi_count : "0" } nos )</Typography>
                        <Box sx={{padding:'8px', background:'#0654AD 0% 0% no-repeat padding-box', borderRadius:'8px'}}>
                          <FaCloudUploadAlt style={{fontSize:'20px'}}/>
                        </Box>
                      </Box>

                      <Box mt={1} sx={{display:'flex', justifyContent:'space-between', alignItems:'center', background:'#055FC64D 0% 0% no-repeat padding-box', borderRadius:'8px', border:'1px solid #055FC6'}}>
                        <Typography padding={'8px'}> PF NO ( {employeeCounts.employee_pf_number_count ? employeeCounts.employee_pf_number_count : "0" } nos )</Typography>
                        <Box sx={{padding:'8px', background:'#0654AD 0% 0% no-repeat padding-box', borderRadius:'8px'}}>
                          <FaCloudUploadAlt style={{fontSize:'20px'}}/>
                        </Box>
                      </Box>

                      <Box mt={1} sx={{display:'flex', justifyContent:'space-between', alignItems:'center', background:'#055FC64D 0% 0% no-repeat padding-box', borderRadius:'8px', border:'1px solid #055FC6'}}>
                        <Typography padding={'8px'}>UAN NO ( {employeeCounts.employee_uan_number_count ? employeeCounts.employee_uan_number_count : "0" } nos )</Typography>
                        <Box sx={{padding:'8px', background:'#0654AD 0% 0% no-repeat padding-box', borderRadius:'8px'}}>
                          <FaCloudUploadAlt style={{fontSize:'20px'}}/>
                        </Box>
                      </Box>
                    

                 

                  </Box>

                  <Box mt={2} sx={{width:'90%', display:'flex', justifyContent:'space-between', borderRadius:'8px', border:'1px solid #F25050'}} onClick={() => {DownloadErrorLogs()}}>
                    <Typography padding={'8px'} color={'#F11919'}> Download Error Logs</Typography>
                    <Box sx={{padding:'8px', background:'#F11919 0% 0% no-repeat padding-box', borderRadius:'8px'}}>
                      <FaCloudDownloadAlt style={{fontSize:'20px'}}/>
                    </Box>
                  </Box>

                </Box>

               

                {/* Output Box */}
                <Box sx={{width:'24%', display:'flex', flexDirection:'column', alignItems:'center'}}>
                  
                  <Box sx={{padding:'20px', width:'100%', height:'330px', background:'#222385 0% 0% no-repeat padding-box', boxShadow:'0px 6px 10px #00000029', borderRadius:'10px'}}>
                      <Box sx={{display:'flex', alignItems:'center'}}>
                        <MdOutput style={{fontSize:'28px'}}/>
                        <Typography display={'flex'} alignItems={'center'} ml={2}> Output &nbsp;<Typography fontSize={'12px'}>(Downloads)</Typography></Typography>
                      </Box>

                      <Box mt={2} sx={{display:'flex', justifyContent:'space-between', alignItems:'center', background:'#055FC64D 0% 0% no-repeat padding-box', borderRadius:'8px', border:'1px solid #055FC6'}}>
                        <Typography padding={'8px'}> Registers</Typography>
                        <Box sx={{padding:'8px', background:'#0654AD 0% 0% no-repeat padding-box', borderRadius:'8px'}}>
                          <FaCloudDownloadAlt style={{fontSize:'20px'}}/>
                        </Box>
                      </Box>

                     
                  </Box>

                  <Box mt={2} sx={{ width:'90%', display:'flex', justifyContent:'space-between', borderRadius:'8px', border:'1px solid #055FC6'}}>
                    <Typography padding={'8px'} color={'#0654AD'}> Download as ZIP</Typography>
                    <Box sx={{padding:'8px', background:'#0654AD 0% 0% no-repeat padding-box', borderRadius:'8px'}}>
                      <FaCloudDownloadAlt style={{fontSize:'20px'}}/>
                    </Box>
                  </Box>

                  <Box mt={2} sx={{ width:'90%', display:'flex', justifyContent:'space-between', borderRadius:'8px', border:'1px solid #055FC6'}}>
                    <Typography padding={'8px'} color={'#0654AD'}> Send Email</Typography>
                    <Box sx={{padding:'8px', background:'#0654AD 0% 0% no-repeat padding-box', borderRadius:'8px'}}>
                      <FaCloudDownloadAlt style={{fontSize:'20px'}}/>
                    </Box>
                  </Box>

                </Box>

              </Box>
            </Box>}

            
        </div>
}
</div>
      }
    </div>
  )
}

export default InputsDashboard





